import React from 'react';
import './Popup.css';
 
export const Popup = React.forwardRef((props, ref) => (
    <div ref={ref} className={`popup popup_type_${props.type} ${props.isOpen ? 'popup__open' : ''}`} >
      {props.children} 
    </div>  
  ));